import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodySM } from "@/domains/design/components/body-sm"
import { WarningSquareIcon } from "@/domains/icons"

export const TokenDialogWarningMessage: React.FC<{
  message: string
  icon?: React.ReactNode
}> = ({ message, icon }) => {
  return (
    <MultilineMessageBox icon={icon ?? <WarningSquareIcon size={20} />} variant="error" size="md">
      <BodySM>{message}</BodySM>
    </MultilineMessageBox>
  )
}
